import React from "react";

import { BarContainer, BarText } from "../styled-components/barstyle"

const Bar = () => {
  return (
    <BarContainer>
      <BarText>Sofia Ringstedt</BarText>
    </BarContainer>
  )
}

export default Bar;